<template>
  <div>
    <b-card no-body>
      <b-card-body>
        <rc-overlay
          :show="loading"
          no-fade
          variant="white"
        >
          <b-card-title>
            {{ $t('navigation.settings.notifications.card-title') }}
          </b-card-title>
          <b-card-sub-title class="mb-2">
            {{ $t('navigation.settings.notifications.card-title-description') }}
          </b-card-sub-title>

          <div v-if="notificationSections.length">
            <section
              v-for="section in notificationSections"
              :key="section.key"
              class="mb-2"
            >
              <header class="mb-1">
                <h5 class="font-weight-bold mb-0">
                  {{ getSectionLabel(section.key) }}
                </h5>
              </header>

              <b-row>
                <b-col
                  v-for="type in section.types"
                  :key="type.key"
                  cols="12"
                  md="4"
                  class="mb-1"
                >
                  <h5 class="font-weight-bold mb-0">
                    {{ getTypeLabel(type.key) }}
                    <b-badge
                      v-if="['Sms', 'Push'].includes(type.key)"
                      variant="info"
                      class="font-small-1"
                    >
                      {{ $t('shared.coming-soon') }}
                    </b-badge>
                  </h5>
                  <div class="mt-75">
                    <b-form-checkbox
                      v-for="notificationKey in type.notifications"
                      :key="notificationKey"
                      v-model="type.value[notificationKey]"
                      class="custom-control-success cursor-pointer d-block mb-50"
                      switch
                      :disabled="['Sms', 'Push'].includes(type.key)"
                      @input="val => saveValue(type.paths[notificationKey], val)"
                    >
                      {{ getNotificationLabel(section.key, notificationKey) }}
                    </b-form-checkbox>
                  </div>
                </b-col>
              </b-row>
            </section>
          </div>
          <div
            v-else
            class="text-center text-muted"
          >
            {{ emptyStateLabel }}
          </div>
        </rc-overlay>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import RcOverlay from '@/layouts/components/rc/RcOverlay'
import notificationSettingsTabSetup from '@/views/organization/settings/account/tabs/notificationSettingsTabSetup'

export default {
  components: {
    RcOverlay,
  },
  setup: notificationSettingsTabSetup,
}
</script>

<style lang="scss" scoped>
</style>
